import { useQuery } from '@tanstack/react-query';

// helper
import { BaseError } from '../../helpers/BaseError';

// models
import {
    AllUsers,
    AudienceModel,
    AudienceStatus,
} from '../../models/audience.model';

// services
import API from '../../services/api';

// query keys
import audienceKeys from './_queryKeys';

const getAudience = async (
    status: AudienceStatus[],
    addAllUsers: boolean,
): Promise<AudienceModel[]> => {
    const { data } = await API.getAudiences({ statuses: status });
    if (addAllUsers) {
        return [...data].reverse().concat(AllUsers);
    } else return data;
};

export default function useAudiencesQuery(
    status: AudienceStatus[] = [
        AudienceStatus.Active,
        AudienceStatus.Available,
        AudienceStatus.Inactive,
    ],
    addAllUsers: boolean = true,
) {
    return useQuery<AudienceModel[], BaseError>({
        queryKey: audienceKeys.audienceIncludeArchive(status, addAllUsers),
        queryFn: () => getAudience(status, addAllUsers),
        staleTime: 60 * 60,
    });
}
